// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page .form-mega-wrap .mega-wrap-inner .form .form-row.opt-check .ci-checkbox {
  --border-color: rgba(var(--app-mid-light-rgb), .8);
  --size: 19px;
}

.page .form-mega-wrap .mega-wrap-inner .form .field-input .fi-input {
  border: 1px solid var(--app-mid-lighter-2);
  border-radius: 5px;
  --padding-start: 8px;
  --padding-end: 8px;
}

.page .form-mega-wrap .mega-wrap-inner .form .field-input .fi-input {
  --padding-top: 12px;
  --padding-bottom: 12px;
  --padding-start: 12px;
  --padding-end: 12px;
}

.page .form-mega-wrap .mega-wrap-inner .form .field-info .fi-lbl, .page .form-mega-wrap .mega-wrap-inner .form .field-help .field-help-inner, .page .form-mega-wrap .mega-wrap-inner .form .form-row.title, .page .form-mega-wrap .mega-wrap-inner .form .form-row.opt-check .oc-lbl {
  word-break: break-all;
  word-break: break-word;
}

.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

.page {
  height: 100%;
  overflow-y: hidden;
  display: flex;
}
.page .img-wrap {
  width: 35%;
  max-width: 500px;
  background-color: #39a1ff;
  display: flex;
  justify-content: center;
}
.page .img-wrap .img {
  /* min- */
  height: 500px;
  max-height: 100%;
}
.page .form-mega-wrap {
  flex: 1;
  padding: 30px 40px 50px;
  overflow-y: auto;
}
.page .form-mega-wrap .mega-wrap-inner {
  min-height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page .form-mega-wrap .mega-wrap-inner .form {
  width: 100%;
  max-width: 400px;
  padding: 0 5px;
  display: grid;
  grid-template-columns: min-content auto;
  gap: 25px 12px;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row {
  grid-column: 1/3;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.btn-submit-wrapper {
  display: flex;
  justify-content: center;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.btn-submit-wrapper > .form-row {
  grid-column: initial;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.fr-btn {
  margin: 0;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.fr-btn.btn-back {
  justify-self: flex-start;
  margin: -15px;
  --border-radius: 100px;
  --padding-top: 5px;
  --padding-bottom: 5px;
  --padding-start: 10px;
  --padding-end: 10px;
  height: auto;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.fr-btn.btn-back .btn-icon {
  font-size: 28px;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.fr-btn.btn-submit {
  justify-self: center;
  margin-top: 20px;
  min-width: 160px;
  font-weight: 600;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.opt-check {
  margin-top: 10px;
  display: flex;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.opt-check .ci-checkbox {
  margin-top: -1px;
  margin-left: 2px;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.opt-check .oc-lbl {
  flex: 1;
  padding-left: 12px;
  color: var(--app-mid);
  font-size: 14px;
  line-height: 1.4;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.opt-check .oc-lbl .lbl-part {
  color: var(--app-main);
  cursor: pointer;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.opt-check .oc-lbl .input-error {
  color: var(--app-danger);
  font-size: 12px;
  -webkit-user-select: none;
          user-select: none;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.tap-pane {
  justify-self: center;
  margin: -5px;
  padding: 5px;
  color: var(--app-mid);
  font-size: 15px;
  cursor: pointer;
  margin-bottom: 10rem;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.tap-pane .lbl-part {
  color: var(--app-main);
  font-weight: 500;
}
.page .form-mega-wrap .mega-wrap-inner .form .form-row.title {
  margin: 0 -5px 20px;
  border-bottom: 1px solid var(--app-mid-lighter-2);
  padding-bottom: 10px;
  color: var(--app-mid-dark);
  font-size: 28px;
  font-weight: 600;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-icon {
  align-self: center;
  font-size: 22px;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-help {
  grid-column: 2/3;
  max-width: calc(400px * .75);
  margin-top: -8px;
  display: flex;
  justify-content: flex-end;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-help .field-help-inner {
  margin: -5px;
  padding: 5px;
  color: var(--app-main);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-info {
  grid-column: 2/3;
  margin-bottom: -23px;
  max-width: calc(400px * .75);
  display: flex;
  align-items: center;
  color: var(--app-mid);
}
.page .form-mega-wrap .mega-wrap-inner .form .field-info .fi-lbl {
  flex: 1;
  font-size: 14px;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-info .fi-icon {
  font-size: 16px;
  cursor: pointer;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-input {
  max-width: calc(400px * .75);
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-input ion-icon {
  position: absolute;
  z-index: 2;
  right: 12px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  color: var(--app-mid-light);
}
.page .form-mega-wrap .mega-wrap-inner .form .field-input .fi-input {
  font-size: 14px;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-input .fi-input.border-danger {
  border-color: var(--app-danger);
}
.page .form-mega-wrap .mega-wrap-inner .form .field-input.field-input--select {
  position: relative;
  cursor: pointer;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-input.field-input--select .fi-input {
  pointer-events: none;
  --padding-end: 43px;
}
.page .form-mega-wrap .mega-wrap-inner .form .field-input.field-input--select .sel-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}
.page .form-mega-wrap .mega-wrap-inner .form .field-input .input-error {
  position: absolute;
  color: var(--app-danger);
  padding: 2px;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/theme/desktop/desktop.scss","webpack://./src/app/components/common/login/login.component.scss"],"names":[],"mappings":"AAkFA;EAEE,kDAAA;EACA,YAAA;AClFF;;AD0KA;EAYE,0CAvLc;EAwLd,kBAAA;EAIC,oBAAA;EACD,kBAAA;ACrLF;;ADwLA;EAIE,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;ACxLF;;AD2OA;EACE,qBAAA;EAEA,sBAAA;ACzOF;;ADyQA;EACE,kBAAA;ACtQF;ADwQE;EACE,gBAAA;ACtQJ;AD0QE;EAwBE;;IAAA;AC7RJ;ADuQI;EACE,uBAAA;ACrQN;ADyQI;EACE,yBAAA;ACvQN;AD0QI;EACE,0BAAA;ACxQN;AD4QI;EACE,sBAAA;AC1QN;AD6QI;EACE,6BAAA;AC3QN;ADkRI;EACE,6BAAA;AChRN;ADmRI;EACE,6BAAA;ACjRN;ADqRI;EACE,2BAAA;ACnRN;ADsRI;EACE,6BAAA;ACpRN;ADuRI;EACE,+BAAA;ACrRN;;AA5DA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;AA+DF;AA7DE;EAGD,UAAA;EACA,gBAAA;EAGA,yBAAA;EAEA,aAAA;EACA,uBAAA;AA0DD;AAxDC;EACE,SAAA;EAAU,aAAA;EACV,gBAAA;AA2DH;AApDE;EACD,OAAA;EACA,uBAAA;EAEA,gBAAA;AAqDD;AAnDC;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAoDH;AAjDG;EACD,WAAA;EAEA,gBADW;EAIX,cAAA;EAEA,aAAA;EACA,uCAAA;EAIA,cAAA;AA4CF;AApCE;EACE,gBAAA;AAsCJ;AAlCI;EACD,aAAA;EACA,uBAAA;AAoCH;AAlCG;EACE,oBAAA;AAoCL;AA/BI;EACD,SAAA;AAiCH;AA/BG;EACE,wBAAA;EAKA,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,YAAA;AA2BL;AAzBK;EACD,eAAA;AA2BJ;AAvBG;EACE,oBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,gBAAA;AAwBL;AAnBI;EACD,gBAAA;EACA,aAAA;AAqBH;AAnBG;EACE,gBAAA;EACA,gBAAA;AAqBL;AAhBG;EACE,OAAA;EACA,kBAxEI;EA4EJ,qBAvEK;EAwEL,eArEE;EAsEF,gBAAA;AAeL;AAbK;EACD,sBA3EU;EA4EV,eAAA;AAeJ;AAXK;EACD,wBAAA;EACA,eAAA;EAEA,yBAAA;UAAA,iBAAA;AAYJ;AAJI;EACD,oBAAA;EAIA,YAAA;EACA,YAHM;EAMN,qBAtGO;EAuGP,eAAA;EAEA,eAAA;EAEA,oBAAA;AADH;AAGG;EACE,sBA7GS;EA8GT,gBAAA;AADL;AAMI;EAGD,mBAAA;EACA,iDDlLa;ECmLb,oBAAA;EAEA,0BAAA;EACA,eAAA;EACA,gBAAA;AAPH;AAiBE;EACE,kBAAA;EACA,eAAA;AAfJ;AAmBE;EACE,gBAAA;EACA,4BA7Ie;EAgJf,gBAAA;EAEA,aAAA;EACA,yBAAA;AApBJ;AAsBI;EACD,YAAA;EACA,YAAA;EAIA,sBA5JW;EA6JX,eAAA;EACA,gBAAA;EAEA,eAAA;EAEA,yBAAA;UAAA,iBAAA;AAzBH;AA8BE;EACE,gBAAA;EAEA,oBAAA;EACA,4BA1Ke;EA4Kf,aAAA;EACA,mBAAA;EAEA,qBAjLM;AAkJV;AAiCI;EAED,OAAA;EACA,eAnLI;AAmJP;AAmCI;EACD,eAAA;EACA,eAAA;AAjCH;AAyCE;EACE,4BAlMe;EAmMf,gBAAA;EAEA,kBAAA;EACA,UAAA;AAxCJ;AA4CI;EACD,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EAGA,QAAA;EACA,2BAAA;EAEA,2BAAA;AA7CH;AAkDI;EAED,eA1NI;AAyKP;AAoDG;EACE,+BAAA;AAlDL;AAyDI;EACD,kBAAA;EACA,eAAA;AAvDH;AAyDG;EACE,oBAAA;EAEA,mBAAA;AAxDL;AA2DG;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EAEA,2BAAA;AA1DL;AAgEI;EACD,kBAAA;EACA,wBAAA;EACA,YAAA;EAGA,yBAAA;UAAA,iBAAA;AAhEH","sourcesContent":["\n\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n$btnShadow:\n  0 3px 1px -2px rgba(0, 0, 0, 0.2),\n  0 2px 2px 0 rgba(0, 0, 0, 0.14),\n  0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n$shadow: 0 8px 16px rgba(var(--app-cover-rgb), .15);\n$shadow-sm: 0 4px 8px rgba(var(--app-cover-rgb), .15);\n\n\n// page\n\n$page_minW: 1280px;\n$page_maxW: 1920px;\n\n\n// >media queries\n\n// large screens: 1080p, 2K, 4K\n$pageWild_w: $page_maxW;\n\n\n// >padding\n\n$page_pb50: 50px;\n$page_pb20: 20px;\n\n$page_pt20: 20px;\n$page_pt30: 30px;\n\n$page_px: 20px;\n$page_py20: 20px;\n\n$page_p: $page_pt20 $page_px $page_pb50;\n$page_p-v2: $page_pt30 $page_px $page_pb50;\n\n\n$popover_p: 10px 0;\n\n\n\n\n\n\n\n%btn {\n  margin: 0;\n  font-weight: 600;\n}\n\n%cardHead {\n  border-bottom: $borderDivider;\n  padding: 9px 12px;\n\n  color: var(--app-mid-dark);\n  // font-size: 17px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n\n\n  /* .card-head-btns {\n    margin-left: auto;\n    padding-left: 20px;\n\n    display: flex;\n    align-items: center;\n  } */\n\n  .card-head-icon {\n    margin-right: 10px;\n    // font-size: 20px;\n    font-size: 18px;\n  }\n\n}\n\n%checkbox {\n  // --border-width: 1px;\n  --border-color: rgba(var(--app-mid-light-rgb), .8);\n  --size: 19px;\n\n  // pointer-events: none;\n}\n\n// aka 'quick actions'\n%mapHudBtns {\n  border-radius: $borderRadius;\n\n  $px: 10px;\n  padding: 7px $px;\n\n  background-color: var(--app-base);\n  display: flex;\n\n  box-shadow: $shadow;\n\n\n  .hqa-btn-wrap {\n\n    .hqa-btn {\n      margin: 0;\n      --border-radius: 50%;\n\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n\n      height: auto;\n\n      font-size: 11px;\n\n      .btn-icon {\n        margin: 8px;\n      }\n    }\n\n\n    &:not(:last-child) {\n      margin-right: $px;\n      border-right: $borderDivider;\n      padding-right: $px;\n    }\n  }\n\n}\n\n%search {\n  /*\n  --background\tBackground of the searchbar\n  --cancel-button-color\tColor of the searchbar cancel button\n  --clear-button-color\tColor of the searchbar clear button\n  --color\tColor of the searchbar text\n  --icon-color\tColor of the searchbar icon\n  --placeholder-color\tColor of the searchbar placeholder\n  --placeholder-font-style\tFont style of the searchbar placeholder\n  --placeholder-font-weight\tFont weight of the searchbar placeholder\n  --placeholder-opacity\tOpacity of the searchbar placeholder\n  */\n\n  border: $borderDivider;\n  // fix: visual glitch\n  --border-radius: #{$borderRadius};\n  border-radius: $borderRadius;\n\n  padding: 0;\n\n  --box-shadow: none;\n}\n\n%statusCircle {\n  border-radius: 50%;\n\n  height: 10px;\n  width: 10px;\n\n  &.status-off {\n    background-color: var(--app-danger);\n  }\n  &.status-on {\n    background-color: var(--app-succ);\n  }\n}\n\n\n// input\n\n%input {\n  // --background\tBackground of the input\n  // --color\tColor of the input text\n  // --padding-bottom\tBottom padding of the input\n  // --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n  // --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n  // --padding-top\tTop padding of the input\n  // --placeholder-color\tColor of the input placeholder text\n  // --placeholder-font-style\tFont style of the input placeholder text\n  // --placeholder-font-weight\tFont weight of the input placeholder text\n  // --placeholder-opacity\tOpacity of the input placeholder text\n\n  border: $borderDivider;\n  border-radius: 5px;\n\n  // --padding-top: 10px;\n  // --padding-bottom: 10px;\n   --padding-start: 8px;\n  --padding-end: 8px;\n}\n\n%input-lg {\n  @extend %input;\n\n  $p: 12px;\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n// modal\n\n%modalFooter {\n  border-top: $borderDivider;\n\tpadding: 10px $page_px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t.foot-btn {\n\t\tmargin: 0;\n    font-weight: 600;\n\n    // .btn-icon {}\n\n    &.mw-120 {\n      min-width: 120px;\n    }\n\t}\n\n\t&::before {\n\t\tcontent: normal;\n\t}\n}\n\n%modalHeader {\n  padding: 15px $page_px;\n  background-color: var(--app-main-darker);\n\n  .head-elem {\n    &.he-title {\n      margin-bottom: 20px;\n\n      &.mb-0 {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.p-20 {\n    padding: $page_py20 $page_px;\n  }\n}\n\n\n// text\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n\n\n\n\nion-header,\nion-content,\nion-footer {\n  //font-size: 15px;\n\n  // works but must be done on project setup\n  // some elems already in use need white-space: nowrap;\n  // @extend %longWord;\n}\n\n\n\n\n\n\n// effect\n\n.ion-activatable {\n  position: relative;\n\n  &.ripple-bounded {\n    overflow: hidden;\n  }\n\n\n  & > ion-ripple-effect.ripple {\n\n    &.contr {\n      color: var(--app-contr);\n    }\n\n\n    &.darkest {\n      color: var(--app-darkest);\n    }\n\n    &.lightest {\n      color: var(--app-lightest);\n    }\n\n\n    &.main {\n      color: var(--app-main);\n    }\n\n    &.main-darker {\n      color: var(--app-main-darker);\n    }\n\n    /*&.main-soft {\n      color: var(--app-main-soft);\n    }*/\n\n    &.main-softer {\n      color: var(--app-main-softer);\n    }\n\n    &.main-strong {\n      color: var(--app-main-strong);\n    }\n\n\n    &.mid-light {\n      color: var(--app-mid-light);\n    }\n\n    &.mid-lighter {\n      color: var(--app-mid-lighter);\n    }\n\n    &.mid-lighter-2 {\n      color: var(--app-mid-lighter-2);\n    }\n\n  }//& > ion-ripple-effect.ripple\n\n}//.ion-activatable\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","@import \"../../../../theme/desktop/desktop\";\n\n\n\n.page {\n  height: 100%;\n  overflow-y: hidden;\n  display: flex;\n\n  .img-wrap {\n\t// padding-top: 20px;\n\n\twidth: 35%;\n\tmax-width: 500px;\n\n\t// background-color: var(--app-main);\n\tbackground-color: #39a1ff;\n\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t.img {\n\t  /* min- */height: 500px;\n\t  max-height: 100%;\n\t  // width: 100%;\n\t}\n  }\n\n\n\n  .form-mega-wrap {\n\tflex: 1;\n\tpadding: $page_pt30 40px $page_pb50;\n\n\toverflow-y: auto;\n\n\t.mega-wrap-inner {\n\t  min-height: 50%;\n\n\t  display: flex;\n\t  align-items: center;\n\t  justify-content: center;\n\n\n\t  .form {\n\t\twidth: 100%;\n\t\t$maxWidth: 400px;\n\t\tmax-width: $maxWidth;\n\n\t\t$form_px: 5px;\n\t\tpadding: 0 $form_px;\n\n\t\tdisplay: grid;\n\t\tgrid-template-columns: min-content auto;\n\n\t\t$gapX: 12px;\n\t\t$gapY: 25px;\n\t\tgap: $gapY $gapX;\n\n\n\t\t$color: var(--app-mid);\n\t\t$colorLink: var(--app-main);\n\t\t$field_maxWidth: calc(#{$maxWidth} * .75);\n\t\t$fz: 14px;\n\n\t\t.form-row {\n\t\t  grid-column: 1/3;\n\n\n\t\t  // BUG lg sbumit btn breaks form\n\t\t  &.btn-submit-wrapper {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\n\t\t\t& > .form-row {\n\t\t\t  grid-column: initial;\n\t\t\t}\n\t\t  }\n\n\n\t\t  &.fr-btn {\n\t\t\tmargin: 0;\n\n\t\t\t&.btn-back {\n\t\t\t  justify-self: flex-start;\n\n\t\t\t  $px: 10px;\n\t\t\t  $py: 5px;\n\n\t\t\t  margin: -$py -$px;\n\t\t\t  --border-radius: 100px;\n\n\t\t\t  --padding-top: #{$py};\n\t\t\t  --padding-bottom: #{$py};\n\t\t\t  --padding-start: #{$px};\n\t\t\t  --padding-end: #{$px};\n\n\t\t\t  height: auto;\n\n\t\t\t  .btn-icon {\n\t\t\t\tfont-size: 28px;\n\t\t\t  }\n\t\t\t}\n\n\t\t\t&.btn-submit {\n\t\t\t  justify-self: center;\n\t\t\t  margin-top: 20px;\n\n\t\t\t  min-width: 160px;\n\t\t\t  font-weight: 600;\n\t\t\t}\n\t\t  }\n\n\n\t\t  &.opt-check {\n\t\t\tmargin-top: 10px;\n\t\t\tdisplay: flex;\n\n\t\t\t.ci-checkbox {\n\t\t\t  margin-top: -1px;\n\t\t\t  margin-left: 2px;\n\t\t\t  @extend %checkbox;\n\t\t\t}\n\n\n\t\t\t.oc-lbl {\n\t\t\t  flex: 1;\n\t\t\t  padding-left: $gapX;\n\n\t\t\t  @extend %longWord;\n\n\t\t\t  color: $color;\n\t\t\t  font-size: $fz;\n\t\t\t  line-height: 1.4;\n\n\t\t\t  .lbl-part {\n\t\t\t\tcolor: $colorLink;\n\t\t\t\tcursor: pointer;\n\t\t\t  }\n\n\t\t\t  // Vigo\n\t\t\t  .input-error{\n\t\t\t\tcolor: var(--app-danger);\n\t\t\t\tfont-size: 12px;\n\t\t\t\t// fdc\n\t\t\t\tuser-select: none;\n\t\t\t  }\n\t\t\t  // END Vigo\n\t\t\t}\n\n\t\t  }\n\n\n\t\t  &.tap-pane {\n\t\t\tjustify-self: center;\n\n\t\t\t$pad: 5px;\n\n\t\t\tmargin: -$pad;\n\t\t\tpadding: $pad;\n\n\n\t\t\tcolor: $color;\n\t\t\tfont-size: 15px;\n\n\t\t\tcursor: pointer;\n\n\t\t\tmargin-bottom: 10rem;\n\n\t\t\t.lbl-part {\n\t\t\t  color: $colorLink;\n\t\t\t  font-weight: 500;\n\t\t\t}\n\t\t  }\n\n\n\t\t  &.title {\n\t\t\t@extend %longWord;\n\n\t\t\tmargin: 0 -#{$form_px} 20px;\n\t\t\tborder-bottom: $borderDivider;\n\t\t\tpadding-bottom: 10px;\n\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-size: 28px;\n\t\t\tfont-weight: 600;\n\t\t  }\n\n\n\t\t}\n\n\n\t\t// ----------------------\n\t\t// field\n\n\t\t.field-icon {\n\t\t  align-self: center;\n\t\t  font-size: 22px;\n\t\t}\n\n\n\t\t.field-help {\n\t\t  grid-column: 2/3;\n\t\t  max-width: $field_maxWidth;\n\n\t\t  // margin-top: -($gapY - 7);\n\t\t  margin-top: -($gapY - 17);\n\n\t\t  display: flex;\n\t\t  justify-content: flex-end;\n\n\t\t  .field-help-inner {\n\t\t\tmargin: -5px;\n\t\t\tpadding: 5px;\n\n\t\t\t@extend %longWord;\n\n\t\t\tcolor: $colorLink;\n\t\t\tfont-size: 13px;\n\t\t\tfont-weight: 500;\n\n\t\t\tcursor: pointer;\n\t\t\t// fdc\n\t\t\tuser-select: none;\n\t\t  }\n\t\t}\n\n\n\t\t.field-info {\n\t\t  grid-column: 2/3;\n\t\t  // margin-bottom: -18px;\n\t\t  margin-bottom: -($gapY - 2);\n\t\t  max-width: $field_maxWidth;\n\n\t\t  display: flex;\n\t\t  align-items: center;\n\n\t\t  color: $color;\n\n\t\t  .fi-lbl {\n\t\t\t@extend %longWord;\n\t\t\tflex: 1;\n\t\t\tfont-size: $fz;\n\t\t  }\n\n\t\t  .fi-icon {\n\t\t\tfont-size: 16px;\n\t\t\tcursor: pointer;\n\t\t  }\n\n\t\t}\n\n\n\t\t// now a component is available\n\t\t// app-input-select\n\t\t.field-input {\n\t\t  max-width: $field_maxWidth;\n\t\t  margin-bottom: 0;\n\t\t  // ion-icon\n\t\t  position: relative;\n\t\t  z-index: 1;\n\n\t\t  // Aggiunta Vigo\n\t\t  // ion-input{\n\t\t  ion-icon {\n\t\t\tposition: absolute;\n\t\t\tz-index: 2;\n\t\t\tright: 12px;\n\t\t\tcursor: pointer;\n\n\t\t\t// fdc\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\n\t\t\tcolor: var(--app-mid-light);\n\t\t  }\n\t\t  // }\n\t\t  // Fine aggiunta Vigo\n\n\t\t  .fi-input {\n\t\t\t@extend %input-lg;\n\t\t\tfont-size: $fz;\n\n\t\t\t// Aggiunta Vigo\n\t\t\t&.border-danger{\n\t\t\t  border-color: var(--app-danger);\n\t\t\t}\n\t\t\t// Fine aggiunta Vigo\n\n\t\t  }\n\n\n\t\t  &.field-input--select {\n\t\t\tposition: relative;\n\t\t\tcursor: pointer;\n\n\t\t\t.fi-input {\n\t\t\t  pointer-events: none;\n\t\t\t  // 12+16+15\n\t\t\t  --padding-end: 43px;\n\t\t\t}\n\n\t\t\t.sel-icon {\n\t\t\t  position: absolute;\n\t\t\t  top: 50%;\n\t\t\t  right: 15px;\n\n\t\t\t  transform: translateY(-50%);\n\t\t\t  // font-size: 16px;\n\t\t\t}\n\t\t  }\n\n\t\t  // Aggiunta Vigo\n\t\t  .input-error{\n\t\t\tposition: absolute;\n\t\t\tcolor: var(--app-danger);\n\t\t\tpadding: 2px;\n\n\t\t\t// fdc\n\t\t\tuser-select: none;\n\t\t  }\n\t\t  // Fine aggiunta Vigo\n\n\n\t\t}\n\n\t\t// END field\n\t\t// ----------------------\n\n\n\t  }\n\n\n\t}\n  }\n\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
